export const Onboard = {
	expiredContent: {
		title: "⚠️ Din onboarding-länk har löpt ut",
		description: `
Hoppsan! Den här länken är inte längre aktiv. Onboarding-länkar löper ut efter en viss tid eller kan endast användas en gång.
Om du ännu inte har satt upp ditt konto, be din administratör att skicka en ny inbjudan.
`,
		footer_content: "Om du redan har slutfört onboarding, kan du",
	},
	unknow_error: {
		title: "Ett oväntat fel inträffade",
		description: "Ett oväntat fel har inträffat. Försök igen senare eller kontakta support om problemet kvarstår.",
	},
	form: {
		title: "Välkommen",
		description:
			"Du har blivit inbjuden att gå med i {{organizationName}} på Lens. Låt oss få dig igång och redo att börja!",
		button_text: "Gå med i {{organizationName}}",
		button_text_loading: "Onboarding...",
	},
	login_link_text: "Logga in",
};
